import { render, staticRenderFns } from "./UiNewCheckbox.vue?vue&type=template&id=02d801e0&scoped=true"
import script from "./UiNewCheckbox.vue?vue&type=script&lang=js"
export * from "./UiNewCheckbox.vue?vue&type=script&lang=js"
import style0 from "./UiNewCheckbox.vue?vue&type=style&index=0&id=02d801e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d801e0",
  null
  
)

export default component.exports